import React, { createContext, useState, useContext } from "react"

const ModalContext = createContext()

export const ModalProvider = ({ children }) => {
  const [activeModal, setActiveModal] = useState(null)
  const [formState, setFormState] = useState({})
  const [currentStep, setCurrentStep] = useState(1)

  const updateFormState = newState => {
    setFormState(prevState => ({
      ...prevState,
      ...newState,
    }))
  }

  const openModal = modalType => {
    setActiveModal(modalType)
  }

  const closeModal = () => {
    setActiveModal(null)
  }

  return (
    <ModalContext.Provider
      value={{
        activeModal,
        openModal,
        closeModal,
        formState,
        updateFormState,
        currentStep,
        setCurrentStep,
      }}
    >
      {children}
    </ModalContext.Provider>
  )
}

export const useModal = () => {
  const context = useContext(ModalContext)
  if (!context) {
    throw new Error("useModal must be used within a ModalProvider")
  }
  return context
}
